// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/PaymentKioskConnectionWarning/style.css
// module id = 2075
// module chunks = 0